import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.scss';

import About from './components/About';
import Contact from './components/Contact';
import Projects from './components/Projects';
import Home from './components/Home';
import Layout from './components/Layout';
import './components/Layout/index.scss';
import Skills from './components/skills';

import useDevMode from './components/devmode/usedevmode';
import DevOverlay from './components/devmode/overlay';
import Terminal from './components/terminal/Terminal';

import { isMobileTerminal } from './utils/isMobileTerminal';
import { attachAudioUnlock } from './utils/unlockAudioOnTouch';
import MobileMessages from './components/MobileMessages'; 

function App() {
    const { mode } = useDevMode();
    const mobileTerminal = isMobileTerminal();
    useEffect(() => {
        if (mobileTerminal) {
            attachAudioUnlock();
        }
    }, [mobileTerminal]);
    
    if (mobileTerminal && mode === 'mobile-msg') {
        return (
            <div className="app-wrapper">
                <MobileMessages />
            </div>
        );
    }
    if (mobileTerminal && mode === 'dev') {
        return (
            <div className="app-wrapper">
                <DevOverlay />
                <Terminal />
            </div>
        );
    }

    
    return (
        <div className="app-wrapper">
            {mode === 'dev' && <DevOverlay />}

            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="about" element={<About />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="skills" element={<Skills />} />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
